import React from 'react';

import { I18n } from '@aws-amplify/core';

import type { WeightCategory } from '@/types';
import * as S from '@/components/views/Report/KimLhc/Report/Steps/Result/styles';

interface WeightCategoryProps {
	data: WeightCategory;
}

function getMainLabel(data: WeightCategory): string {
	if (data.inclinedWeight) {
		return `${data.value}kg, ${I18n.get('with load inclination')}`;
	}

	if (data.transportingCargoInPairs) {
		return `${data.value}kg, ${I18n.get('transported in pairs')}`;
	}

	return `${data.value}kg`;
}

export function WeightCategory({ data }: Readonly<WeightCategoryProps>): JSX.Element {
	const mainLabel = getMainLabel(data);

	return (
		<S.AccordionContent>
			<S.ContentText>{mainLabel}</S.ContentText>
			<S.ContentRow>
				<S.ContentLabel>{I18n.get('Effective weight')}: </S.ContentLabel>
				<S.ContentValue>
					{data.effectiveWeight}kg*
				</S.ContentValue>
			</S.ContentRow>
			<S.ContentNote>
				*{I18n.get('The effective weight is the adjusted load weight used in the risk score calculation')}
			</S.ContentNote>
		</S.AccordionContent>
	);
}
